/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";
import { useCurrentDynamicField } from "cms/fields/hooks/use-current-dynamic-field";

const NotImplementedFieldEdit = () => {
    
    const { field } = useCurrentDynamicField();
    const { type } = field || {};
    
    return (
        <Fragment>
            <div className='simplicity-composer-field-primary-layout field-editor'>
                {/*<div className='simplicity-composer-field-primary'>*/}
                <div style={{
                    display: "flex", justifyContent: "center", alignItems: "center",
                    height: "200px", width: "100%",
                }}
                >
                    <p><b>{type} not implemented</b></p>
                </div>
                {/*</div>*/}
            </div>
        </Fragment>
    );
};
NotImplementedFieldEdit.displayName = "NotImplementedFieldEdit";
export {
    NotImplementedFieldEdit
};
